module.exports = __webpack_public_path__ + "static/assets/17f08403f12daff6297d46f3cd203acc.gif";